/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2022-09-19 11:42:43
 * @LastEditors: suzhen suzhen@dianzhong.com
 * @LastEditTime: 2024-04-18 20:27:30
 * @Description  : 文件简介
 */
import { getUserId, getStorage, getSessionStorage } from '@/utils/cookie.js'
import axios from "axios";
import router from '@/router/index.js'
import storeState from '../store/index'
import { showDialog, showConfirmDialog, showToast } from 'vant'
import project from '../../package.json'

let log_idx = 1
const codeMsg = {
	'0': '分享成功',
	'-1': '未知错误',
	'-2': '您手动取消了分享',
	'-3': '系统发送失败',
	'-4': '第三方未获取分享权限或获取权限失败',
	'-5': '文件解析错误 '
}
const smallCode = {
	"20002": "无效请求参数",
	"20003": "授权失败/无权限",
	"20004": "用户手动取消登录",
	"20005": "用户未授权使用相册",
	"20006": "请求授权时网络出错",
	"20007": "视频不支持",
	"20008": "分享图文不支持",
	"20010": "解析媒体资源失败",
	"20011": "视频尺寸或比例不支持",
	"20012": "视频格式不支持",
	"20013": "用户手动取消发布",
	"20015": "用户存为草稿",
	"20017": "无效的链接",
	"20018": "无效的用户",
	"22001": "不支持的分辨率"
}

// 媒体类型
export const mediaEnu = {
	ks: 3,
	dy: 2,
	ws: 1,
	dp: 6,
	tg: 100,
	tgm: 101,
	dyxt: 103,
	dyVideoTypeList: [100, 101, 102, 103, 104, 105, 106], // 抖音视频类型
	'1': '微信短剧', // 视频号
	'3': '快手短剧',
	'2': '抖音口令',        // 抖音短剧
	'6': '抖音小说',
	'100': '抖音短剧',      // 微剧吧-抖音小程序-推广计划-支付
	'101': '免费短剧',      // 微剧吧-抖音小程序-推广计划-广告
	'103': '融合任务',      // 微剧吧-抖音小程序-融合任务
	'104': '小禾任务',      // 小禾任务-抖音小程序-推广计划
	'105': '抖音短剧',      // 微剧吧-抖音小程序
	'106': '星图任务',		// 微剧吧-抖音小程序-星图任务
	'tgTaskType': 'tg',	   // 推广任务
	'xtTaskType': 'xt',    // 星图任务
	'reTaskType': 're',    // 推广链接
	'rhTaskType': 'rh',    // 融合任务
	'1-m': '微信',
	'3-m': '快手',
	'2-m': '抖音',
	'6-m': '抖音',
	'100-m': '抖音短剧',
	'101-m': '免费短剧',
	'微剧吧': 'https://video-h5.wqxsw.com/ttyd/image/plan-pay.png',
	'蜜蜂短剧': 'https://video-h5.wqxsw.com/ttyd/image/mfdj.png',
	'1-medianame': '微信', 		// 微剧吧 =》 微信
	'3-medianame': '快手',		// 微剧吧 =》 快手
	'100-medianame': '抖音',    // 微剧吧 =》 抖音
	'101-medianame': '抖音',    // 微剧吧 =》 抖音
	'103-medianame': '抖音',    // 微剧吧 =》 抖音
	'104-medianame': '抖音',    // 小禾   =》 抖音
	'105-medianame': '抖音',    // 微剧吧 =》 抖音
	'106-medianame': '抖音',    // 微剧吧 =》 抖音
	'wx-medianame': '微信',     // 微信
	'ks-medianame': '快手',     // 快手
	'dy-medianame': '抖音',     // 抖音
	'100-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/dy-icon.png', // 微剧吧 =》 抖音logo
	'101-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/dy-icon.png', // 微剧吧 =》 抖音logo
	'103-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/dy-icon.png', // 融合   =》 抖音logo
	'104-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/dy-icon.png', // 小禾   =》 抖音logo
	'105-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/dy-icon.png', // 抖音logo（汇总）
	'106-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/dy-icon.png', // 抖音星图
	'wx-medialogo': '/icon/wx-icon.png',   // 微剧吧 =》 微信logo
	'ks-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/ks-icon.png',   // 微剧吧 =》 快手logo
	'dy-medialogo': 'https://video-h5.wqxsw.com/ttyd/img/dy-icon.png',   // 抖音logo
	'1-coms': 'https://video-h5.wqxsw.com/ttyd/image/wjb-logo.png',     // 微剧吧 =》 公司logo
	'2-coms': 'https://video-h5.wqxsw.com/ttyd/image/xh-logo.png',           // 小禾   =》 公司logo
}

export const week = 1 // 提现时间
// 发版版本号（与APP版本保持一致）
export const version = '1.0.4'
// 前端项目版本号（不依赖app）
export const projectVersion = project.version

// 获取机型 
export function os() {
	var u = navigator.userAgent
	var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
	var IsAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
	if (IsAndroid) {
		return 0
	} else if (isIos) {
		return 1
	} else {
		return 0
	}
}

// 生成随机数
export function randomStr(num) {
	let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
	let length = num || 16
	let result = ''
	for (let i = length; i > 0; --i) {
		result += chars[Math.floor(Math.random() * chars.length)]
	}
	return result
}

// 随机字符串
export function dateFormatTime(value) {
	var date = new Date(value);
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	var minute = date.getMinutes();
	var second = date.getSeconds();
	minute = minute < 10 ? ('0' + minute) : minute;
	second = second < 10 ? ('0' + second) : second;
	return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second; //年月日时分秒
	// return y + '-' + m + '-' + d + ' ' + h + ':' + minute;
}

// 获取当前版本号
export function getVs() {
	return version
}

// 获取当前域名的appId
export function textByCode(code, scode = '') {
	if (!!code || code === 0) return codeMsg[code] || '错误异常'
	if (scode) return smallCode[scode] || ''
}

export const getQueryString = (search) => {
	if (search) {
		let q = search.substring(1)
		q = q.split('&')
		if (q.length > 0) {
			let query = q.reduce((c, v) => {
				let q1 = v.split('=');
				if (q1.length == 2) {
					c[q1[0]] = q1[1]
					return c
				}
			}, {})
			return query
		}
	}
	return ''
}

// 加密银行卡号
export function encryptionBank(value) {
	let curValue = String(value)
	let len = curValue.length - 4 > 0 ? curValue.length - 4 : 1
	let let1 = curValue.length - 7 > 0 ? curValue.length - 7 : 1
	if (curValue.length > 12) {//银行卡
		return curValue.slice(0, 4) + "*".repeat(len) + value.slice(-4);
	} else {//手机号账户
		return curValue.slice(0, 3) + "*".repeat(let1) + value.slice(-4);
	}
}

// 加密姓名
export function encryptionName(value) {
	let name = String(value)
	let len = name.length > 0 ? name.length : 1
	return name.slice(0, 1) + "*".repeat(len - 1)
}

export function formatDate(data) {
	let date = new Date(data)
	const year = date.getFullYear()
	let month = date.getMonth() + 1
	month = month < 10 ? ('0' + month) : month;
	let d = date.getDate()
	d = d < 10 ? ('0' + d) : d;

	return year + '' + month + '' + d
}

export function timeToMinute(times) {
	let t = '';
	if (times > -1) {
		// let hour = Math.floor(times/3600);
		let min = Math.floor(times / 60) % 60;
		let sec = times % 60;
		//   if(hour < 10) {
		//     t = '0'+ hour + ":";
		//   } else {
		//     t = hour + ":";
		//   }
		if (min < 10) { t += "0"; }
		t += min + ":";
		if (sec < 10) { t += "0"; }
		t += sec.toFixed(2);
	}
	t = t.substring(0, t.length - 3);
	return t;
}

export function myParseFloat(num) {
	return parseFloat(num) ? parseFloat(num) : num;
}

export function sliceString(str) {
	var r = parseFloat(str)
	var result
	if (r) {
		r += ''
		result = str.slice(r.length)
		return result;
	} else {
		return '';
	}
}

export function payInfoLog() {
	let query = router.currentRoute.value.query
	let queryCBtime = query.cBtime
	if (queryCBtime) {
		let cBtimeStorage = window.localStorage.getItem('cBtime') || ''
		cBtimeStorage = cBtimeStorage ? JSON.parse(cBtimeStorage) : {}
		if (!cBtimeStorage[queryCBtime]) {
			console.log('链接支付取消打点')
			h5Log('orderRust', 'recharge', 'event', { ...query, payInfoCancel: 1 })
			cBtimeStorage[queryCBtime] = 1;
			window.localStorage.setItem('cBtime', JSON.stringify(cBtimeStorage))
		}
	} else {
		window.localStorage.getItem('cBtime') && window.localStorage.removeItem('cBtime')
	}
}

/**
 * @description: 是否强制检测
 * @param {*} falg true是强制提醒结果
 * @return {*}
 */
export function downloadNewV(falg) {
	// window.VideoJsBridge = {version:function(){return JSON.stringify({env: 'debug', version: '1.0.0' })}}
	if (window.VideoJsBridge) {
		console.log('window.VideoJsBridge.version()', window.VideoJsBridge.version())
		try {
			let params = JSON.parse(window.VideoJsBridge.version())
			if (params.version != version) {
				// let apkLs= params.url.split('/')
				let url = `https://download.cps24.dzods.cn/dz_${params.env}_v${version}.apk`
				showConfirmDialog({
					message: '检测到有新版本是否升级为V' + version,
					className: 'dowload-app',
					confirmButtonColor: '#2386FF'
				}).then(() => {
					if (window.VideoJsBridge.upgrade) {
						window.VideoJsBridge.upgrade(url)
						return false
					}

					let aNewDoa = document.createElement("a");
					aNewDoa.style.display = "none";
					// 给a标签创建下载的链接
					aNewDoa.href = url
					console.log('下载地址：', url)
					// 下载后文件名
					aNewDoa.download = `dz_${params.env}_v${version}.apk`;
					// 把a标签作为子节点插入当前body下
					document.body.appendChild(aNewDoa);
					// 点击a标签下载
					aNewDoa.click();
					// 下载完成移除元素
					document.body.removeChild(aNewDoa);
				})
			} else {
				if (falg) {
					showDialog({
						message: '当前已是新版本了',
						theme: 'round-button',
						closeOnClickOverlay: true,
						confirmButtonColor: '#2386FF',
						confirmButtonText: '我知道了'
					})
				}
			}
		} catch (error) {
			console.log(error)
		}

	} else {
		if (falg) showDialog({
			message: '当前已是新版本了', theme: 'round-button', closeOnClickOverlay: true, confirmButtonColor: '#2386FF',
			confirmButtonText: '我知道了'
		})
	}
}

/**
 * @description: 防抖函数: 只执行最后一次(输入框)
 * @param {*} fn 回调
 * @param {*} delay 防抖时间 默认值500ms
 * @return {*}
 */
export const debounce = (fn, delay) => {
	var timer = null;
	return function () {
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(() => {
			fn.apply(this, arguments); // this和参数
			clearTimeout(timer);
			timer = null;
		}, delay || 500);
	};
}

/**
 * @description: 节流函数：一段时间内只执行一次，立即执行(按钮)
 * @param {*} fn 回调
 * @param {*} delay 防抖时间 默认值500ms
 * @return {*}
 */
export const throttle = (fn, delay) => {
	var timer = null;
	return function () {
		if (timer) {
			return false
		}
		timer = setTimeout(() => {
			fn.apply(this, arguments); // this和参数
			clearTimeout(timer);
			timer = null;
		}, delay || 500);
	};
}

/**
 * @description: 复制文本
 * @param {*} text 文本
 * @param {*} 提示文案
 * @return {*}
 */
export const copyToClipboard = (text, msg) => {
	if(!text) return false
	var textarea = document.createElement('textarea');
	textarea.style.position = 'fixed';
	textarea.style.opacity = 0;
	textarea.value = text;
	document.body.appendChild(textarea);
	textarea.select();
	document.execCommand('copy');
	document.body.removeChild(textarea);
	showToast(`复制${msg || ''}成功`)
	console.log('复制成功')
}

//打点函数
export function h5Log(key1, key2, action, params) {
	let setQuery = getStorage('readQuery', true)
	if (!Object.keys(setQuery).length) {
		setQuery = localStorage.getItem('readQuery') || ''
	}
	try {
		let data = {
			log_idx: log_idx++,
			ctime: dateFormatTime(Date.parse(new Date())),
			ip: '', // ip地址
			openid: getStorage('hoid') || '', // 小程序openID
			unionid: '' || '', // 小程序unionid
			brand: '', // 手机品牌
			model: '', // 机型
			uid: getUserId() || '', // uid
			vn: version, // 版本号
			apn: getSessionStorage('network') || 'none', // 	wifi，4G
			chid: setQuery.channelId || '', // 渠道号
			pkna: 'com.koc.xcx',
			app_name: 'koc-video',
			app: location.href,
			vip: setQuery.vip || '',//0/1,NO/YES
			ptx: os() ? 1 : 2, //2 安卓 1 IOS
			sessionid: getStorage('sessionid'), //每次启动用户的随机sessionId 20位数字字符
			key1: key1,
			key2: key2,
			action: action,
			data: params, // 其他参数
			ext: {
				// query:getApp().globalData.query, 启动参数
				rid: setQuery.referral_id || '', // 来源id
				utdid: getStorage('utdid'),
				query: setQuery
			} // 扩展字段
		};

		if (process.env.NODE_ENV === 'production') {
			axios({
				method: 'GET',
				url: 'https://log.kyread.cn/jinyi_log.php',
				dataType: 'json',
				params: {
					json: JSON.stringify(data)
				}
			})
		} else {
			console.log('打点参数', data)
		}
	} catch (e) {
		console.log(e)
	}
}

export function getWordSize(num) {
	let size = ''
	if(num > 10000) {
		size = num/10000
		return size.toFixed(0) + '万'
	} else {
		size = num/1000 || 1
		return size.toFixed(2) + '千'
	}
}

/**
 * @description: 获取当前公司信息
 * @param {*} value
 * @param {*} type
 * @return {*}
 */
export function getCompanyInfo(value, type) {
	let com = storeState.getters.companyList.find(i => i.company_type == value) || {}
	if (com.logo) {
		if(type== 'name') return com.company_name
		if(type== 'logo') return com.logo
	}
  }